/**
 * Initialize vue, vue-router, and vuex.
 */
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store' // Vuex Store

/**
 * Helpers for Component registration.
 * Only used here in `main.js`
 */
import upperFirst from 'lodash/upperFirst'
import camelCase from 'lodash/camelCase'
import {
  InlineSvgPlugin
} from 'vue-inline-svg';

/**
 * Touch, swipe, zoom, pan navigations with Hammer.js
 */

// import { VueHammer } from 'vue2-hammer'

/**
 * Player controls handled by Plyr library
 */
import VuePlyr from 'vue-plyr'
import 'vue-plyr/dist/vue-plyr.css' // Plyr default styles
import '@/styles/plyr.custom.css' // Plyr custom overrides.

/**
 * Slider controls handled by Flickity library
 */
import Flickity from 'vue-flickity'

/**
 * Slider controls handled by Flickity library
 */
// import { Localised } from './mixins/Localised.js'

// Vue.mixin({
//   methods: {
//     Localised
//   }
// })


// Tell Vue to use the vendor components.
// Vue.use(VueHammer)
Vue.use(VuePlyr)
Vue.use(Flickity)
Vue.use(InlineSvgPlugin);

/**
 * 1a. Automatic component registration
 */
const requireComponent = require.context(
  // The relative path of the components folder
  './components',
  // Whether or not to look in subfolders
  false,
  // The regular expression used to match base component filenames
  /Base[A-Z]\w+\.(vue|js)$/
)

/**
 * 2a. Automatic component registration
 */
requireComponent.keys().forEach(fileName => {
  // Get component config
  const componentConfig = requireComponent(fileName)

  // Get PascalCase name of component
  const componentName = upperFirst(
    camelCase(
      // Gets the file name regardless of folder depth
      fileName
      .split('/')
      .pop()
      .replace(/\.\w+$/, '')
    )
  )

  /**
   * 3a. Automatic component registration
   */
  // Register component globally
  Vue.component(
    componentName,
    // Look for the component options on `.default`, which will
    // exist if the component was exported with `export default`,
    // otherwise fall back to module's root.
    componentConfig.default || componentConfig
  )
})

/**
 * 1b. Apply all configs to the main Vue instance.
 */
Vue.config.productionTip = false

/**
 * 2b. Apply all configs to the main Vue instance.
 */
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')